export default __webpack_public_path__ + "static/media/blog2.e6f96d8b.jpg";